// extracted by mini-css-extract-plugin
export default {"loader":"LoaderTransition-module__loader","animate":"LoaderTransition-module__animate","pda":"LoaderTransition-module__pda"};